export function getRemaining(stripped?: string, limit?: number) {
  if (stripped === undefined || limit === undefined) {
    return undefined;
  }
  return Math.max(limit - stripped.length, 0);
}
